import {utils, writeFile} from "xlsx";

export const exportarJsonToExcel = ({data, nombre = 'NA'}) => {
    const worksheet = utils.json_to_sheet(data);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Sheet1");
    writeFile(workbook, nombre + ".xlsx");
}